import React, { useState, useEffect } from 'react';
import '../../styles/Website/Spreads.css';

function Spreads() {
  const [priceCards, setPriceCards] = useState([
    {
      pair: 'EURUSD',
      baseBid: 1.1769,
      baseAsk: 1.1770,
      change: -0.07,
      changePositive: false,
      volatility: 0.00002,
      lastUpdate: 'up'
    },
    {
      pair: 'AUDUSD',
      baseBid: 0.6709,
      baseAsk: 0.6716,
      change: 0.17,
      changePositive: true,
      volatility: 0.00003,
      lastUpdate: 'up'
    },
    {
      pair: 'GBPUSD',
      baseBid: 1.3494,
      baseAsk: 1.3498,
      change: -0.20,
      changePositive: false,
      volatility: 0.00003,
      lastUpdate: 'down'
    },
    {
      pair: 'XAUUSD',
      baseBid: 4531.00,
      baseAsk: 4531.40,
      change: 0.59,
      changePositive: true,
      volatility: 0.05,
      lastUpdate: 'up'
    }
  ]);

  useEffect(() => {
    const interval = setInterval(() => {
      setPriceCards(prevCards => 
        prevCards.map(card => {
          // Simulate realistic price movement
          const bidChange = (Math.random() - 0.5) * 2 * card.volatility;
          const askChange = (Math.random() - 0.5) * 2 * card.volatility;
          
          const newBid = card.baseBid + bidChange;
          const newAsk = card.baseAsk + askChange;
          
          // Ensure ask is always higher than bid
          const finalAsk = Math.max(newAsk, newBid + (card.pair === 'XAUUSD' ? 0.4 : 0.0001));
          
          // Calculate change percentage
          const changePercent = ((newBid - card.baseBid) / card.baseBid) * 100;
          const isPositive = changePercent > 0;
          
          // Determine last update direction
          const lastUpdate = bidChange > 0 ? 'up' : 'down';
          
          return {
            ...card,
            baseBid: newBid,
            baseAsk: finalAsk,
            change: card.change + (Math.random() - 0.5) * 0.02,
            changePositive: card.change > 0,
            lastUpdate
          };
        })
      );
    }, 1500); // Update every 1.5 seconds

    return () => clearInterval(interval);
  }, []);

  const formatPrice = (price, pair) => {
    if (pair === 'XAUUSD') {
      const whole = Math.floor(price);
      const decimal = ((price - whole) * 100).toFixed(0).padStart(2, '0');
      return {
        main: `${whole}.`,
        decimal: decimal
      };
    } else {
      const priceStr = price.toFixed(5);
      const parts = priceStr.split('.');
      return {
        main: `${parts[0]}.${parts[1].substring(0, 2)}`,
        decimal: parts[1].substring(2)
      };
    }
  };

  const calculateSpread = (bid, ask, pair) => {
    if (pair === 'XAUUSD') {
      return (ask - bid).toFixed(1);
    } else {
      return ((ask - bid) * 10000).toFixed(1);
    }
  };

  return (
    <section className="spreads-hero">
      <div className="spreads-container">
        <div className="price-cards">
          {priceCards.map((card, index) => {
            const bidFormatted = formatPrice(card.baseBid, card.pair);
            const askFormatted = formatPrice(card.baseAsk, card.pair);
            const spread = calculateSpread(card.baseBid, card.baseAsk, card.pair);
            
            return (
              <div className={`price-card ${card.lastUpdate}`} key={index}>
                <div className="price-card-header">
                  <span className="pair-name">{card.pair}</span>
                  <div className="price-change-wrapper">
                    <span className="chart-icon">📈</span>
                    <span className={`price-change ${card.changePositive ? 'positive' : 'negative'}`}>
                      {card.change > 0 ? '+' : ''}{card.change.toFixed(2)}% {card.changePositive ? '▲' : '▼'}
                    </span>
                  </div>
                </div>
                
                <div className="price-display">
                  <div className="price-column">
                    <div className="price-label">Bid</div>
                    <div className="price-value">
                      {bidFormatted.main}
                      <span className="price-decimal">{bidFormatted.decimal}</span>
                    </div>
                  </div>
                  
                  <div className="price-column">
                    <div className="price-label">Ask</div>
                    <div className="price-value">
                      {askFormatted.main}
                      <span className="price-decimal">{askFormatted.decimal}</span>
                    </div>
                  </div>
                </div>
                
                <div className="price-footer">
                  <span className="spread-label">Spread</span>
                  <span className="spread-value">{spread}</span>
                  <div className="action-buttons">
                    <button className="btn-buy">BUY</button>
                    <button className="btn-sell">SELL</button>
                  </div>
                </div>
                
                <div className="live-indicator-spread" style={{ color: "#0f0" }}>
                  <span className="pulse-dot"></span>
                  LIVE
                </div>
              </div>
            );
          })}
        </div>
        
        <div className="spreads-content">
          <h2 className="spreads-title">The Raw Spread Advantage</h2>
          <p className="spreads-description">
            Raw Spreads are the difference you have been waiting for. Trade with spreads from 0.0 pips, 
            no requotes, best possible prices and no restrictions. HijaAsset is the multi-asset 
            trading platform of choice for high volume traders, scalpers and robots.
          </p>
          <div className="spreads-actions">
            <button className="btn-start-trading">Start Trading</button>
            <button className="btn-try-demo">Try a Free Demo</button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Spreads;